import rootReducer from './rootReducer';

export default [
  '$ngReduxProvider',
  $ngReduxProvider => {
    $ngReduxProvider.createStoreWith(
      rootReducer,
      [],
      window._RAILS_ENV === 'development' && window.__REDUX_DEVTOOLS_EXTENSION__
        ? [window.__REDUX_DEVTOOLS_EXTENSION__()]
        : []
    );
  }
];
